export default "__VITE_ASSET__C8_77ozO__"